/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateTimecardNote} from '../api'

export const useMutationUpdateTimecardNote = createReactQueryMutationHook('updateTimecardNote', updateTimecardNote)
